<div class="new-permission-assignment-container">
    <div *ngIf="subjectType === PermissionSubjectType.USER" class="mb-24">
        <lib-user-table [capabilities]="{canUpdate: false, canDelete: false}"
                        [selectable]="true" [detailsOnSelect]="false"
                        [selectedRowStyle]="{'background-color': SELECTED_USER_COLOR}"
                        [pageSize]="5" [pageSizeOptions]="[5, 10, 15]"
                        [filter]="userFilter"
                        (selected)="onSelectUser($event)">
        </lib-user-table>
        <div *ngIf="!user" fxLayout="row" fxLayoutAlign="center">
            {{'Please select a user'|i18n}}
        </div>
        <ng-container *ngIf="user">
            <ng-container *ngIf="assignments; else loadingAssignments">
                <ng-container *ngIf="canAssign">
                    <app-permission-assignments *ngIf="assignments.length"
                                                [readOnly]="true"
                                                [hideSubject]="true"
                                                [assignments]="assignments">
                    </app-permission-assignments>
                    <div fxLayout="row" fxLayoutAlign="center" class="mt-24 mb-16">
                        <ng-container *ngIf="!objectAssignment">
                            <span *ngIf="object.hint">
                                {{'New permissions for {0} on {1}'|i18n:user.username:object.hint|i18n}}
                            </span>
                            <span *ngIf="!object.hint">
                                {{'New permissions for {0}'|i18n:user.username}}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="objectAssignment">
                            <span *ngIf="object.hint">
                                {{'Permissions for {0} on {1}'|i18n:user.username:object.hint}}
                            </span>
                            <span *ngIf="!object.hint">
                                {{'Permissions for {0}'|i18n:user.username}}
                            </span>
                        </ng-container>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1rem" class="ml-24 mr-24">
                        <app-permission-list [readOnly]="false"
                                             [settings]="object.permissionSettings"
                                             [permissions]="permissions"
                                             (permissionsChange)="onChangePermissions(PermissionSubjectType.USER, user.u3id, $event)">
                        </app-permission-list>
                        <button *ngIf="permissions.length"
                                mat-icon-button color="primary" class="perm-operation-button"
                                (click)="onClickClearPermissions(PermissionSubjectType.USER, user.u3id)"
                                [title]="'Remove all permissions'|i18n">
                            <app-icon name="fal-times-circle"></app-icon>
                        </button>
                    </div>
                </ng-container>
                <div *ngIf="!canAssign" fxLayout="row" fxLayoutAlign="center">
                    <span>{{'Not allowed to assign permissions to user {0}'|i18n:user.username}}</span>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>

<ng-template #loadingAssignments>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-24 mb-16">
        <mat-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{'Loading permission assignments'|i18n}}...</span>
    </div>
</ng-template>
